import React from 'react';
import Lottie from 'react-lottie';
import Text from '@common/text';
import Button from '@common/button';
import fireCracker from '@graphic/fireCracker.json';
import NhisCompanyReportHistoryDto from '@domain/rs/nhis/NhisCompanyReportHistoryDto';
import { FontStyle } from '@domain/constant/fontStyle';
import Colors from '@domain/constant/colors';
import classnames from 'classnames/bind';
import styles from './index.module.scss';

const cx = classnames.bind(styles);

const options = {
  loop: true,
  autoplay: true,
  animationData: fireCracker,
};

interface Step4Props {
  onClose: () => void;
  selectedCompanies: NhisCompanyReportHistoryDto[];
}

const Step7 = ({ onClose, selectedCompanies }: Step4Props) => {
  const count = selectedCompanies?.length || 0;

  return (
    <div className={cx('area')}>
      <div className={cx('wrap')}>
        <div className={cx('titleArea')}>
          <Text fontStyle={FontStyle.B2_M} color={Colors.C_GREEN_200}>
            축하해요! 총 {count}개의 경력이 등록되었어요. 🎉
          </Text>
          <Text fontStyle={FontStyle.H5_B} color={Colors.C_COOL_GRAY_90}>
            각 경력마다 역할, 주요 성과를 작성하고,
            <br />
            채용 담당자에게 더 많은 제안을 받아보세요!
          </Text>
        </div>

        <div className={cx('contentsArea')}>
          <Lottie options={options} isClickToPauseDisabled />
        </div>
      </div>

      <div className={cx('btnArea')}>
        <Button className={cx('btn')} type={'button'} onClick={onClose}>
          확인
        </Button>
      </div>
    </div>
  );
};

export default Step7;
